import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { ErrorMessage } from 'formik';

const FormikAsyncCreatableSelect = ({
  field: { name, value },
  form: { setFieldValue },
  label,
  keys,
  loadOptions,
  getNewOptionData,
  required = false,
  ...rest
}) => {
  const handleChange = (item) => {
    setFieldValue(name, item);
  };

  const customFormatCreateLabel = (inputValue) => {
    return `Create a new option: "${inputValue}"`; // Customize the label as needed
  };

  return (
    <FormGroup className="flex-grow-1">
      {label && (
        <Label for={rest.id} className="label-color">
          {label}
          {required && <span style={{ color: 'red', marginLeft: '2px' }}>*</span>}
        </Label>
      )}
      <AsyncCreatableSelect
        name={name}
        value={value}
        placeholder={rest.placeholder || 'Type to search'}
        loadOptions={loadOptions}
        onChange={handleChange}
        classNamePrefix="react-select"
        formatCreateLabel={customFormatCreateLabel}
        onCreateOption={(newValue) => {
          setFieldValue(name, getNewOptionData(newValue, ''));
        }}
        getNewOptionData={getNewOptionData}
        backspaceRemovesValue
        {...rest}
      />
      <ErrorMessage
        name={name}
        render={(msg) => <div className="text-danger font-size-12">{msg}</div>}
      />
    </FormGroup>
  );
};

export default FormikAsyncCreatableSelect;
